import type { ComponentProps, HTMLAttributes } from "react"
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu"
import { ChevronRight } from "lucide-react"
import './menu.scss'

const DropdownMenu = DropdownMenuPrimitive.Root

const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger

const DropdownMenuSub = DropdownMenuPrimitive.Sub

/**
 * `chevron={false}`, wenn der Aufrufer den Pfeil selbst setzt — die Zeilen des **Aufgaben-Menüs**
 * (`MenuSub`) stellen ihn hinter Haken und Kürzel.
 */
function DropdownMenuSubTrigger({ className, children, chevron = true, ...props }: ComponentProps<typeof DropdownMenuPrimitive.SubTrigger> & { chevron?: boolean }) {
  return (
    <DropdownMenuPrimitive.SubTrigger
      className={`context-menu-content__item ${className || ''}`}
      {...props}
    >
      {children}
      {chevron && <ChevronRight size={16} className="context-menu-content__sub-chevron" />}
    </DropdownMenuPrimitive.SubTrigger>
  )
}

function DropdownMenuSubContent({ className, ...props }: ComponentProps<typeof DropdownMenuPrimitive.SubContent>) {
  return (
    <DropdownMenuPrimitive.Portal>
      <DropdownMenuPrimitive.SubContent
        className={`context-menu-content ${className || ''}`}
        {...props}
      />
    </DropdownMenuPrimitive.Portal>
  )
}

function DropdownMenuContent({ className, sideOffset = 4, ...props }: ComponentProps<typeof DropdownMenuPrimitive.Content>) {
  return (
    <DropdownMenuPrimitive.Portal>
      <DropdownMenuPrimitive.Content
        sideOffset={sideOffset}
        collisionPadding={{ top: 56, bottom: 8, left: 8, right: 8 }}
        className={`context-menu-content ${className || ''}`}
        {...props}
      />
    </DropdownMenuPrimitive.Portal>
  )
}

function DropdownMenuItem({ className, ...props }: ComponentProps<typeof DropdownMenuPrimitive.Item>) {
  return (
    <DropdownMenuPrimitive.Item
      className={`context-menu-content__item ${className || ''}`}
      {...props}
    />
  )
}

function DropdownMenuSeparator({ className, ...props }: ComponentProps<typeof DropdownMenuPrimitive.Separator>) {
  return (
    <DropdownMenuPrimitive.Separator
      className={`context-menu-content__separator ${className || ''}`}
      {...props}
    />
  )
}

function DropdownMenuLabel({ className, ...props }: ComponentProps<typeof DropdownMenuPrimitive.Label>) {
  return (
    <DropdownMenuPrimitive.Label
      className={`context-menu-content__label ${className || ''}`}
      {...props}
    />
  )
}

/** Eine Gruppe von Einträgen — wie `ContextMenuGroup`. */
const DropdownMenuGroup = DropdownMenuPrimitive.Group

/** Der rechte Rand einer Zeile: Haken, Kürzel, Pfeil — wie `ContextMenuItemTrailing`. */
function DropdownMenuItemTrailing({ className, ...props }: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={`context-menu-content__item-trailing ${className || ''}`}
      {...props}
    />
  )
}

function DropdownMenuShortcut({ className, ...props }: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={`context-menu-content__shortcut ${className || ''}`}
      {...props}
    />
  )
}

export {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuGroup,
  DropdownMenuItemTrailing,
  DropdownMenuSeparator,
  DropdownMenuLabel,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuSubContent,
}
